
import styled from "styled-components"
import Btn from "../../shared/button/Btn"

import arrIcon from "../../../images/svg/jobList/arr2.svg"
import konum1 from "../../../images/svg/jobList/konum1.svg"
import konum2 from "../../../images/svg/jobList/konum2.svg"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { handleFrameState, setAracBekleyenYukCheckedItem } from "../../../features/joblist/jobListSlice"
import moment from "moment"
import formatConverter from "../../../helper/formatConverter"
import fiyatlandirmaTipOptions from "../../../utils/yukOptions/fiyatlandirmaTipOptions"
import priceReverseCalculator from "../../../helper/priceReverseCalculator"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import { BsCheck } from "react-icons/bs"
import { Link, useNavigate } from "react-router-dom"
import useWindowDimensions from "../../../hooks/useWindowSize"

const Container = styled.div`
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${({theme}) => theme.mainTextColor};

    .topp-container{
        width: 100%;
        margin-bottom: 5px;

        h2{
            text-align: center;
            font-size: var(--font-size-xl);
            font-weight: var(--font-weight-xl);
        }
    }

    .content-container{
        width: 100%;
        display: flex;
        flex-direction: column;
        border: 3px solid ${({theme}) => theme.mainBorderColor};
        padding: 5px;
        border-radius: 10px;
        position: relative;

        .arr-btn{
            position: absolute;
            top: 0;
            left: 0;
        }


        .content-top-container{
            width: 100%;
            margin-top: 20px;
        }

        .main-content{
            width: 100%;
            display: flex;
            flex-direction: column;

            .content-list{
                display: flex;
                flex-direction: column;
                gap: 10px;
            }
        }
    }
    
`

const ContentItem = styled.div`
    width: 100%;
    padding: 10px;
    padding-bottom: 25px;
    border: 2px solid ${({theme}) => theme.mainBorderColor};
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    background-color: ${({theme, isChecked}) => isChecked ? "rgba(250, 136, 136, 0.1)" : theme.mainBgColor};
    .row-grp{
        display: flex;
        flex-direction: column;
        gap: 5px;

    .row-item{
        display: flex;
        align-items: flex-start;

        &:first-child{
            margin-right: 5px;
        }

        .item-title{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-xl);
            display: flex;
            align-items: center;
            gap: 5px;
            width: 130px;
        }

        .item-data{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            display: flex;
            align-items: center;
            gap: 5px;
        }

        .checkbox{
            width: 20px;
            height: 20px;
            border-radius: 4px;
            border: 1px solid ${({theme, isChecked}) => !isChecked ? theme.mainTextColor : "none"};
            background-color: ${({theme, isChecked}) => isChecked ? "var(--color-main)" : theme.secondaryBgColor};
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;

              .check-icon{
                  font-size: 2.6rem;
                  color: #fff;
              }
        }      

        .inner{
          padding-left: 10px;
        }

        .colored{
          color: var(--color-main);
          font-weight: var(--font-weight-lg);
        }
    }
    
    .seperator{
        height: auto;
        width: 2px;
        background-color: ${({theme}) => theme.mainTextColor};
    }

}

  .row-grp-location{
    display: flex;
    flex-direction: column;

    .item-title{
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-xl);
      display: flex;
      align-items: center;
      gap: 5px;
      width: 130px;
      margin-left: -6px;
    }

    .item-title-2{
      margin-left: 0;
    }

    .konum-container{
      display: flex;
      flex-direction: column;
      gap: 2px;
      
      .konum-item{
        display: flex;
        flex-direction: column;
        gap: 2px;

        div{
          padding-left: 15px;
        }

        .sm-data{
          font-size: 12px;
        }


        .dashed{
          border-left: 1px dashed${({theme}) => theme.mainTextColor};
        }
        
      }

      .item-location{
        position: relative;

        img{
          position: absolute;
          top: 2px;
          left: -7px;
          width: 15px;
        }

      }
    }

    .sm-konum-container{
      display: flex;
      gap: 5px;

      .konum-side{
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;

        .img{
          width: 12px;
        }

        .line{
          border-left: 1px dashed ${({theme}) => theme.mainTextColor};
          height: 15px;
        }
      }

      .data-side{
        display: flex;
        flex-direction: column;
        gap: 5px;

        .item-location{
          padding-bottom: 2px;
        }
      }
    }
    
    .colored{
        color: var(--color-main);
        font-weight: var(--font-weight-lg);
      }

      .inner{
        padding-top: 5px;
        padding-left: 15px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
      }

    }
    
  .placeholder{
    visibility: hidden;
  }
  
  .underline{
    text-decoration: underline;
  }

  .row-grp:nth-child(1){
    width: 5%;
  }
  .row-grp:nth-child(2){
    /* width: 30%; */
    width: 25%;
  }
  .row-grp:nth-child(3){
    /* width: 20%; */
    width: 30%;
  }
  .row-grp:nth-child(4){
    width: 20%;
  }
  .row-grp:nth-child(5){
    /* width: 25%; */
    width: 20%;
  }

  .more-btn{
      font-size: 10px;
      font-weight: var(--font-weight-md);
      color: ${({theme, isOpened}) => isOpened ? "var(--color-main)" : theme.secondaryTextColor};
      position: absolute;
      bottom: 4px;
      right: 6px;
      cursor: pointer;
  }

  
  @media (max-width: 1500px){

  }
`


const WideYukSide = ({loadList, isLoading, checkedItem}) => {

    const [isOpenedItemId, setIsOpenedItemId] = useState(null)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {windowDimensions} = useWindowDimensions()

    const changeFrame = () => {
        if(windowDimensions?.width < 1500){
            dispatch(handleFrameState("aracSide"))
        }else{
            dispatch(handleFrameState("equal"))
        }
        
    }

  return (
    <Container>
        <div className="topp-container">
            <h2>Araç Bekleyen Yükler</h2>
        </div>
        <div className="content-container">
            <button className="arr-btn" onClick={changeFrame}>
                <img src={arrIcon} alt=""/>
            </button>
            <div className="content-top-container">
                <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"220px"} handleClick={() => navigate("/yuk-ekle")}>+ Yeni Yük Ekle</Btn>
            </div>
            <div className="main-content">
                {
                    isLoading ? <SmallSpinner size={"50px"} color={"#fff"} bgColor={"#E85446"}/>  
                    :
                    <div className="content-list">
                        {
                            loadList.map(item => {
                                if(item.id === isOpenedItemId){
                                    return (
                                        <ContentItem isOpened={item.id === isOpenedItemId}>
                                            <div className="row-grp">
                                                <div className="row-item">
                                        <button className="checkbox"onClick={() => { dispatch(setAracBekleyenYukCheckedItem(item?.id !== checkedItem?.id ? item : null ))}}>
                                            {
                                                item?.id === checkedItem?.id &&
                                                <BsCheck className="check-icon"/>
                                            }
                                        </button>
                                                </div>
                                            </div>
                                            <div className="row-grp">
                                                <div className="row-item">
                                                    <div className="item-title underline">Talep Detayı</div>
                                                    <div className="item-data placeholder">---</div>
                                                </div>
                                                <div className="row-item">
                                                    <div className="item-title">Yük No</div>
                                                    <div className="item-data">{item.id}</div>
                                                </div>
                                                <div className="row-item">
                                                    <div className="item-title">Araç Türü</div>
                                                    <div className="item-data">{item.truckType}</div>
                                                </div>
                                                <div className="row-item">
                                                    <div className="item-title">Kasa Türü</div>
                                                    <div className="item-data">{item.trailerType}</div>
                                                </div>
                                                <div className="row-item">
                                                    <div className="item-title">Araç Sayısı</div>
                                                    <div className="item-data">{item.truckQuantity} Araç</div>
                                                </div>
                                                <div className="row-item">
                                                    <div className="item-title">Kayıt Zamanı</div>
                                                    <div className="item-data">{moment(item?.routePoints?.$values[0]?.loadDate)?.format("DD.MM.YYYY")} - {item.routePoints.$values[0].loadTime}</div>
                                                </div>
                                            </div>

                                            <div className="row-grp row-grp-location">
                                                <div className="item-title underline">Nereden - Nereye</div>
                                                  <div className="konum-container">
                                                    <div className="konum-item">
                                                        <div className="item-location colored">{item.routePoints.$values[0].location}
                                                          <img src={konum1} alt="" />
                                                        </div>
                                                        <div className="sm-data dashed">{moment(item?.routePoints?.$values[0]?.loadDate)?.format("DD.MM.YYYY")} - {item.routePoints.$values[0].loadTime}</div>
                                                        <div className="sm-data dashed">Rampadan-Forklift var</div>
                                                    </div>

                                                    <div className="konum-item">
                                                        <div className="item-location colored border-none">{item.routePoints.$values[item?.routePoints?.$values.length -1].location}
                                                          <img src={konum2} alt="" />
                                                        </div>
                                                          <div className="sm-data border-none">{moment(item?.routePoints?.$values[item?.routePoints?.$values.length -1]?.loadDate)?.format("DD.MM.YYYY")} - {item.routePoints.$values[item?.routePoints?.$values.length - 1].loadTime}</div>
                                                        <div className="sm-data">Rampadan-Forklift var</div>
                                                    </div>
                                                    <div className="inner">{item.distance} Km {item.routePoints.$values.length > 2 && `- ${(item.routePoints.$values.length -2)} Durak`}</div>
                                              </div>
                                            </div>
                                            <div className="row-grp">
                                                <div className="row-item">
                                                  <div className="item-title underline">Yük</div>
                                                  <div className="item-title placeholder">---</div>
                                                </div>
                                                <div className="row-item">
                                                  <div className="item-title">Yükün Türü</div>
                                                  <div className="item-data colored">{item.loadType}</div>
                                                </div>
                                                <div className="row-item">
                                                  <div className="item-title">Yük Sahibi</div>
                                                  <div className="item-data"></div>
                                                </div>
                                                <div className="row-item">
                                                  <div className="item-title">Yükleme Türü</div>
                                                  <div className="item-data">{item.isParsiyel ? "Parsiyel" : "Komple"}</div>
                                                </div>
                                                <div className="row-item">
                                                  <div div className="item-title">Yük Miktarı</div>
                                                  <div className="item-data">{item.loadQuantity} {item.loadUnit}</div>
                                                </div>
                                                <div className="row-item">
                                                  <div className="item-title">Paketleme</div>
                                                  <div className="item-data">Paletli</div>
                                                </div>
                                            </div>
                                            
                                            <div className="row-grp">
                                                <div className="row-item">
                                                  <div className="item-title underline">Ödeme</div>
                                                  <div className="item-title placeholder">---</div>
                                                </div>

                                                <div className="row-item">
                                                  <div className="item-title">Fiyat</div>
                                                  <div className="item-data colored">{formatConverter(item.freight, 0)} + {fiyatlandirmaTipOptions.find(innerItem=> innerItem.value === item.paymentUnit)?.text} + KDV</div>
                                                </div>

                                                <div className="row-item">
                                                  <div className="item-title">Ödeme Şekli</div>
                                                  <div className="item-data">{item.paymentType}</div>
                                                </div>

                                                <div className="row-item">
                                                  <div className="item-title">Komisyon</div>
                                                    {
                                                      item.commissionPaymentId !== 0 ?
                                                      <div className="item-data">{item.commissionPaymentId === 1 ? `%${item.commissionPayment}` : item.commissionPaymentId === 2 && `${item.commissionPayment} TL`} - {item.commissionPaymentId === 1 ? `${formatConverter(priceReverseCalculator(item.freight, item.commissionPaymentId, item.commissionPayment), 0)} TL` : item.commissionPaymentId === 2 && `%${formatConverter(priceReverseCalculator(item.freight, item.commissionPaymentId, item.commissionPayment), 0)}`}</div>
                                                      :<div className="item-data">Yok</div>
                                                    }
                                                </div>
                                                <div className="row-item">
                                                  <div className="item-title">Fiyat TL/Km</div>
                                                  <div className="item-data">{item.paymentUnit === 0 ? formatConverter((item.freight/item.distance), 0) : formatConverter(((item.freight*item.loadQuantity)/item.distance),0)} TL</div>
                                                </div>
                                                <div className="row-item">
                                                  <div className="item-title">Teklif Sayısı</div>
                                                  <div className="item-data">{item?.aspiredLoads?.$values?.length} Teklif</div>
                                                </div>
                                                <div className="row-item">
                                                  <div className="item-title">En Düşük Teklif</div>
                                                  <div className="item-data">
                                                        {item?.aspiredLoads?.$values && formatConverter(
                                                          item?.aspiredLoads?.$values?.reduce((min, item) =>
                                                          item.offerValue < min.offerValue ? item : min
                                                          )?.offerValue,
                                                          0
                                                        )} TL
                                                    </div>
                                                </div>
                                            </div>
                                        <button className="more-btn" onClick={() => setIsOpenedItemId(null)}>Detaylar kapat</button>
                                    </ContentItem>
                                    )
                                }
                                else{
                                    return (
                                      <ContentItem isOpened={item.id === isOpenedItemId} isChecked={item?.id === checkedItem?.id}>
                                      <div className="row-grp">
                                          <div className="row-item">
                                          <button className="checkbox"onClick={() => { dispatch(setAracBekleyenYukCheckedItem(item?.id !== checkedItem?.id ? item : null ))}}>
                                            {
                                                item?.id === checkedItem?.id &&
                                                <BsCheck className="check-icon"/>
                                            }
                                        </button>
                                          </div>
                                      </div>
                                      <div className="row-grp">
                                          <div className="row-item">
                                              <div className="item-title underline">Talep Detayı</div>
                                              <div className="item-data placeholder">---</div>
                                          </div>
                                          <div className="row-item">
                                              <div className="item-title">Yük No</div>
                                              <div className="item-data">{item.id}</div>
                                          </div>
                                          <div className="row-item">
                                              <div className="item-title">Araç Türü</div>
                                              <div className="item-data">{item.truckType}</div>
                                          </div>
                                      </div>

                                      <div className="row-grp row-grp-location">
                                          <div className="item-title item-title-2 underline">Nereden - Nereye</div>
                                            <div className="sm-konum-container">
                                              <div className="konum-side">
                                                <img src={konum1} className="img" alt="Nereden" />
                                                <div className="line"></div>
                                                <img src={konum2} className="img" alt="Nereden" />
                                              </div>
                                              <div className="data-side">
                                                <div className="item-location colored border-none">{item.routePoints.$values[0].location}</div>
                                                <div className="item-location colored border-none">{item.routePoints.$values[item?.routePoints?.$values.length -1].location}</div>
                                              </div>

                                            </div>
                                      </div>

                                      <div className="row-grp">
                                          <div className="row-item">
                                            <div className="item-title underline">Yük</div>
                                            <div className="item-title placeholder">---</div>
                                          </div>
                                          <div className="row-item">
                                            <div className="item-title">Yükün Türü</div>
                                            <div className="item-data colored">{item.loadType}</div>
                                          </div>
                                          <div className="row-item">
                                            <div className="item-title">Yük Sahibi</div>
                                            <div className="item-data"></div>
                                          </div>
                                      </div>
                                      
                                      <div className="row-grp">
                                          <div className="row-item">
                                            <div className="item-title underline">Ödeme</div>
                                            <div className="item-title placeholder">---</div>
                                          </div>

                                          <div className="row-item">
                                            <div className="item-title">Fiyat</div>
                                            <div className="item-data colored">{formatConverter(item.freight, 0)} + {fiyatlandirmaTipOptions.find(innerItem=> innerItem.value === item.paymentUnit)?.text} + KDV</div>
                                          </div>

                                          <div className="row-item">
                                            <div className="item-title">Teklif Sayısı</div>
                                            {
                                            item?.aspiredLoads?.$values?.length > 0 &&
                                            <div className="item-data">{item?.aspiredLoads?.$values?.length} Teklif - {formatConverter(
                                                item?.aspiredLoads?.$values?.reduce((min, item) =>
                                                item.offerValue < min.offerValue ? item : min
                                                )?.offerValue,
                                                0
                                            )} TL</div>
                                         }
                                          </div>
                                      </div>
                                  <button className="more-btn" onClick={() => setIsOpenedItemId(item.id)}>Detaylar için tıklayın</button>
                              </ContentItem>
                                    )
                                }
                            })
                        }
                    </div>
                }
            </div>

        </div>
    </Container>
  )
}

export default WideYukSide 